import React, { useRef, useState } from 'react';
import { Mic, Upload, CheckCircle2, Play, Pause, Volume2, Sparkles } from 'lucide-react';

export function VoiceCloneCard({
  voiceName = 'Mi Voz Personal',
  isCloned = false,
  onAudioUpload,
  voiceAudioUrl = null,
  onOpenRecorder
}) {
  const fileInputRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioElem, setAudioElem] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onAudioUpload) {
      const url = URL.createObjectURL(file);
      onAudioUpload(url, file.name);
    }
  };

  const togglePlay = () => {
    if (!voiceAudioUrl) return;
    if (!audioElem) {
      const audio = new Audio(voiceAudioUrl);
      audio.onended = () => setIsPlaying(false);
      audio.play();
      setAudioElem(audio);
      setIsPlaying(true);
    } else {
      if (isPlaying) {
        audioElem.pause();
        setIsPlaying(false);
      } else {
        audioElem.play();
        setIsPlaying(true);
      }
    }
  };

  return (
    <div style={{
      padding: '14px',
      background: 'linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 100%)',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.08)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <span style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Mic size={13} color="#ff9101" /> Clon de Voz IA
        </span>
        <span style={{
          fontSize: '11px',
          color: isCloned ? '#10b981' : '#f59e0b',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          background: isCloned ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)',
          padding: '2px 7px',
          borderRadius: '12px'
        }}>
          <CheckCircle2 size={12} /> {isCloned ? 'Voz Sincronizada' : 'Muestra Pendiente'}
        </span>
      </div>

      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <button
          type="button"
          onClick={togglePlay}
          disabled={!voiceAudioUrl}
          style={{
            width: '46px',
            height: '46px',
            borderRadius: '10px',
            background: voiceAudioUrl ? 'linear-gradient(135deg, rgba(255,145,1,0.2), rgba(168,85,247,0.2))' : '#141724',
            border: voiceAudioUrl ? '1px solid rgba(255,145,1,0.4)' : '1px solid rgba(255,255,255,0.06)',
            color: voiceAudioUrl ? '#ff9101' : '#64748b',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: voiceAudioUrl ? 'pointer' : 'default',
            flexShrink: 0
          }}
          title={voiceAudioUrl ? (isPlaying ? 'Pausar muestra' : 'Escuchar muestra') : 'Carga un audio primero'}
        >
          {isPlaying ? <Pause size={20} /> : <Play size={20} style={{ marginLeft: '2px' }} />}
        </button>

        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: '#f1f5f9' }}>{voiceName}</div>
          <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
            {voiceAudioUrl ? 'Perfil acústico y modulación calibrada' : 'Sube 30-60 seg de tu voz hablando'}
          </div>

          <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
            {onOpenRecorder && (
              <button
                type="button"
                onClick={onOpenRecorder}
                style={{
                  background: 'linear-gradient(135deg, rgba(255,145,1,0.2), rgba(168,85,247,0.2))',
                  border: '1px solid rgba(255,145,1,0.5)',
                  color: '#ff9101',
                  borderRadius: '6px',
                  padding: '3px 8px',
                  fontSize: '10px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <Mic size={11} /> Calibrar con Micrófono
              </button>
            )}

            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.15)',
                color: '#e2e8f0',
                borderRadius: '6px',
                padding: '3px 8px',
                fontSize: '10px',
                fontWeight: 500,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <Upload size={11} /> Subir Audio
            </button>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="audio/*"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
}
